// extracted by mini-css-extract-plugin
export default {"overlay":"CardOverlay_overlay__y79Wf","content":"CardOverlay_content__c1RrA"};